<template>
  <a-modal
    :title="'审核'"
    okText="确定"
    @ok="save"
    v-model="visible"
    :width="450"
    wrapClassName="recommend-modal"
  >
    <p :style="{ marginTop: '20px' }">确定客户信息无误，可上线？</p>
  </a-modal>
</template>

<script>
import Api from "@/api";
export default {
  name: "EditMessage",
  props: {
    callback: {
      type: Function
    }
  },
  created() {},
  data() {
    return {
      visible: false,
      company: ""
    };
  },
  watch: {},
  methods: {
    save() {
      let params = {
        company_id: this.company.id
      };
      console.log(params);
      Api.client.reviewPass(params).then(res => {
        console.log(res);
        if (res) {
          this.$message.success("添加成功");
          this.callback && this.callback();
          this.visible = false;
        } else {
          this.$message.error("添加失败");
        }
      });
    },

    show(item) {
      this.visible = true;
      console.log(item);
      this.company = item;
      this.$nextTick().then(() => {});
    },
    close() {
      this.visible = false;
    }
  }
};
</script>

<style lang="scss"></style>
